import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";

import { ITipoPagamento } from "interfaces/payment";
import { IEventoResponse } from "interfaces/eventos";
import { createTypePayEvento } from "services/evento";
import {
  tipoPayModalHeaderSx,
  tipoPayModalPaperSx,
} from "../tipos-pagamento-evento.theme";

interface Props {
  open: boolean;
  handleClose: () => void;
  evento: IEventoResponse;
  updateEvento: () => void;
  disponiveis: ITipoPagamento[];
}

export default function ModalSelectPayment({
  open,
  handleClose,
  evento,
  updateEvento,
  disponiveis,
}: Props) {
  const handleAddTypePaymentEvento = (selectedPay: ITipoPagamento) => {
    createTypePayEvento({
      eventoId: evento.id,
      tiposPagamentoId: selectedPay.id,
      taxa: Number(selectedPay.taxa_transacao),
      taxaIsPercentage: selectedPay.taxaIsPercentage,
    }).then(() => {
      handleClose();
      updateEvento();
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      fullWidth
      PaperProps={{ sx: tipoPayModalPaperSx }}
    >
      <Box sx={tipoPayModalHeaderSx}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box
            component="img"
            src={evento.urlImageDestaque}
            alt={evento.titulo}
            sx={{
              width: 56,
              height: 56,
              borderRadius: 1.5,
              objectFit: "cover",
              border: "2px solid rgba(255,255,255,0.2)",
              flexShrink: 0,
            }}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="overline"
              sx={{ opacity: 0.75, letterSpacing: 1 }}
            >
              Adicionar pagamento
            </Typography>
            <Typography variant="subtitle1" fontWeight={700} noWrap>
              {evento.titulo}
            </Typography>
          </Box>
          <IconButton
            onClick={handleClose}
            sx={{ color: "inherit" }}
            aria-label="Fechar"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </Box>

      <DialogContent sx={{ p: { xs: 2, sm: 2.5 }, overflow: "auto" }}>
        {disponiveis.length > 0 ? (
          <List
            sx={{
              border: "1px solid",
              borderColor: "grey.200",
              borderRadius: 2,
              overflow: "hidden",
            }}
            disablePadding
          >
            {disponiveis.map((row) => (
              <ListItem key={row.id} disablePadding divider>
                <ListItemButton
                  onClick={() => handleAddTypePaymentEvento(row)}
                  sx={{
                    py: 1.5,
                    "&:hover": { bgcolor: "rgba(249, 96, 48, 0.04)" },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 72 }}>
                    <Box
                      component="img"
                      src={row.icon}
                      alt={row.tipoPagamento}
                      sx={{ width: 56, height: 36, objectFit: "contain" }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={row.tipoPagamento}
                    secondary={
                      row.taxaIsPercentage
                        ? `Taxa: ${row.taxa_transacao}%`
                        : `Taxa: R$ ${row.taxa_transacao}`
                    }
                    primaryTypographyProps={{ fontWeight: 600 }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        ) : (
          <Stack alignItems="center" py={4} spacing={1}>
            <CreditCardOutlinedIcon sx={{ fontSize: 40, color: "grey.400" }} />
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Todos os tipos de pagamento ativos já estão vinculados a este
              evento.
            </Typography>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}
